(() => {
  if (customElements.get('gallery-explainer-video')) return;
  class GalleryExplainerVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-explainer-toggle]');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches;
      this.visible = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.pause();
        else this.play();
      }, options);
      this.video.addEventListener('play', () => {
        // A play event while the flag is set can only come from the native controls, so the shopper wants it playing.
        this.userPaused = false;
        this.syncState();
      }, options);
      this.video.addEventListener('pause', () => {
        if (!this.automaticPause && this.visible && !document.hidden) this.userPaused = true;
        this.automaticPause = false;
        this.syncState();
      }, options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.button.hidden = true;
        this.querySelector('[data-explainer-error]').hidden = false;
      }, options);
      this.motion.addEventListener('change', event => {
        if (event.matches) {
          this.userPaused = true;
          this.pause();
        }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.play();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].intersectionRatio >= 0.25;
        if (this.visible) this.play();
        else this.pause();
      }, { threshold: [0, 0.25] });
      this.observer.observe(this.video);
      this.syncState();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
    }
    play() {
      if (!this.video || this.userPaused || !this.visible || document.hidden || this.failed) return;
      this.video.play()?.catch(() => {
        this.userPaused = true;
        this.syncState();
      });
    }
    pause() {
      if (!this.video || this.video.paused) return;
      this.automaticPause = true;
      this.video.pause();
    }
    syncState() {
      const playing = !this.video.paused && !this.video.ended;
      this.toggleAttribute('playing', playing);
      this.button.setAttribute('aria-label', playing ? this.button.dataset.labelPause : this.button.dataset.labelPlay);
    }
  }
  customElements.define('gallery-explainer-video', GalleryExplainerVideo);
})();
